import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconLocationPinExclamation: React.FC<Props> = ({
  width = 24,
  height = 24,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.5C7.313 2.5 3.5 6.313 3.5 11C3.5 15.983 8.12902 19.041 11.192 21.064L11.722 21.416C11.806 21.472 11.903 21.5 11.999 21.5C12.095 21.5 12.192 21.472 12.276 21.416L12.806 21.064C15.869 19.041 20.498 15.983 20.498 11C20.5 6.313 16.687 2.5 12 2.5ZM11.25 8C11.25 7.586 11.586 7.25 12 7.25C12.414 7.25 12.75 7.586 12.75 8V11C12.75 11.414 12.414 11.75 12 11.75C11.586 11.75 11.25 11.414 11.25 11V8ZM12.02 15C11.468 15 11.015 14.552 11.015 14C11.015 13.448 11.458 13 12.01 13H12.02C12.573 13 13.02 13.448 13.02 14C13.02 14.552 12.572 15 12.02 15Z"
      fill={color}
    />
  </svg>
);

export default IconLocationPinExclamation;
